import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Subtitle, Description, Title, Titlespan2 } from '../../components/title/index';
import Button from '../../components/button';
import { Servicedata, Servicedata1 } from '../../data/service/index';
import PreviewIcon from '../../components/icon';
import '../service/service.scss';

const Service = (props) => {
    return (
        <section className="service-wrapper" id="service">
            <Container>
                <Row>
                    <Col lg={5} md={4}>
                        <div className="service-content-1 main-title-wrapper">
                            <Titlespan2
                                Class="sitemain-subtitle"
                                Name={props.home? 'Business Transformation' : "Who are we"}
                                Label=""
                            />
                            <Title
                                Class="service-title"
                                Name="Our core business"
                            />
                            <Description
                                Class="service-dec"
                                Name="NGT Transformation Services works with you to provide key business solutions"
                            />
                            <Button
                                Class="button1 btn button2 gradient-color"
                                Name="Explore"
                                BtnIcon="btn-icon"
                                Clickble={() => { window.location.replace('/who-we-are'); }}
                            />
                        </div>
                    </Col>
                    <Col lg={7} md={8} className="service-block-content">
                        <Row>
                            {props.home && <Col sm={6} className="service-block2">
                            <h4>It’s time to reimagine everything—relationships, data, technologies, 
                                the workforce, procurement, finance, the customer experience, and more. 
                                It’s time to explore an entire universe of possibilities, solutions, and to 
                                make an impact.</h4>
                            </Col>}
                            {props.home && <Col sm={6} className="service-block1">
                                <ul>
                                <li>Digital Transformation</li>
                                <li>Consulting</li>
                                <li>Delivering Products &amp; Services</li>
                                <li>Company Turnaround</li>
                                <li>Organization and talent</li>
                                <li>Company strategy and LRP (Long range Planning)</li>
                                <li>Sales, Marketing and insights</li>
                                <li>Customer Experience</li>
                                <li>Cost Transformation</li>
                                <li>Procurement Optimization</li>
                                <li>Operations </li>
                                <li>Managing Change and implementation</li>
                                <li>M&amp;A and Investments.</li>
                                </ul>

                            </Col>} 
                        {props.serviceBlock &&<Col sm={6} className="service-block1">
                                {Servicedata.map((data, i) => (
                                    <div className={`service-${i} service-content`} key={data.id}>
                                        <div className="service-icon">
                                            <span><PreviewIcon icon={data.Icon} /></span>
                                        </div>
                                        <div className="service-content-dec">
                                            <Title Class="service-title" Name={data.title} />
                                            <Description Class="service-dec-content" Name={data.content} />
                                        </div>
                                    </div>
                                ))}
                            </Col>}
                            {props.serviceBlock && <Col sm={6} className="service-block2">
                                {Servicedata1.map((data, i) => (
                                    <div className={`service-${i} service-content`} key={data.id}>
                                        <div className="service-icon">
                                            <span><PreviewIcon icon={data.Icon} /></span>
                                        </div>
                                        <div className="service-content-dec">
                                            <Title Class="service-title" Name={data.title} />
                                            <Description Class="service-dec-content" Name={data.content} />
                                        </div>
                                    </div>
                                ))}
                            </Col>}
                        </Row>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Service;
